<template>
  <div id="Login">
    <v-layout>
      <v-flex xs12 sm6 offset-sm3 class="mt-2">
        <v-card>
          <v-card-media src="/static/logo_ub.png" height="150px" contain></v-card-media>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{ $t('login.TITLE') }}</h3>
              <span class="grey--text">{{ $t('login.SUBTITLE') }}</span>
            </div>
            <div>
              <p class="blue--text mb-0 mt-2">{{ $t('login.SET_PASS') }}</p>
              <p class="grey--text">{{ $t('login.MINIM_PASS') }}</p>
            </div>
          </v-card-title>
          <v-flex xs10 sm6 offset-sm3 offset-xs1>
            <v-text-field
              name="password"
              :label="$t('forms.ENTER_PASSWORD')"
              hint=""
              v-model="password"
              :rules="passwordRules"
              :append-icon="e1 ? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
            ></v-text-field>
          </v-flex>
          <v-flex xs10 sm6 offset-sm3 offset-xs1>
            <v-text-field
              name="repeatedPassword"
              :label="$t('forms.REPEAT_PASSWORD')"
              hint=""
              v-model="repeatedPassword"
              :rules="repeatedPasswordRules"
              :append-icon="e2 ? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (e2 = !e2)"
              :type="e2 ? 'password' : 'text'"
            ></v-text-field>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn primary @click.native="submit()" :disabled="!validPassword">{{ $t('login.ACTION_FINISH') }}</v-btn>
          </v-card-actions>
        </v-card>
        <p class="body-2 text-xs-center mt-4">{{ $t('login.FOOTER_PROJECT') }}</p>
        <p class="body-1 text-xs-center">{{ $t('login.FOOTER_IP') }}</p>
        <p class="caption text-xs-center">{{ $t('login.FOOTER_COPYRIGHT') }}</p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import {TokenResource} from '../api/token'

  export default {
    name: 'tokenRegistration',
    data () {
      return {
        token: '',
        password: '',
        repeatedPassword: '',
        error: false,
        e1: true,
        e2: true,
        repeatedPasswordRules: [
          (p) => p === this.password || this.$t('login.MUST_MATCH')
        ],
        passwordRules: [
          (p) => p.length > 5 || this.$t('login.MINIM_PASS')
        ]
      }
    },
    computed: {
      validPassword: function () {
        return (this.password !== '' && this.repeatedPassword !== '' &&
          this.password === this.repeatedPassword && this.password.length > 5)
      }
    },
    methods: {
      submit () {
        var data = {
          token: this.$route.query.token,
          password: this.password
        }
        TokenResource().save(data).then(response => {
          console.log(response)
          this.$router.push({ name: 'Login' })
        }, response => {
          // Error management
          console.log(response)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TokenRegistration.vue